import App from '../shared/components/App';
import React from 'react';
import ThemeProvider from '@zg-rentals/multibrand-ui/lib/ThemeProvider';
import assign from 'lodash/assign';
import configureStore from '../shared/flux/configureStore';
import createHistory from 'history/createBrowserHistory';
import { Router } from 'react-router-dom';
import { push, replace } from 'redux-first-history';
import { CookiesProvider } from 'react-cookie';
import { Provider } from 'react-redux';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';
import { ThemeConstellation } from '@zillow/constellation';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import { HydrationBoundary, QueryClient, QueryClientProvider } from '@zg-rentals/react-query5';
import { bootstrap } from './bootstrap';
import { Auth } from '../shared/AuthProvider';
import { createRoot } from 'react-dom/client';

bootstrap.register();

const initialState = window.__INITIAL_STATE__;
const { store, history } = configureStore(initialState, createHistory());
window.store = store;
window.browserHistory = history;
const brand = store.getState().app.brand || 'zillow';

window.browserHistory.listen((location, action) => {
  if (action === 'POP') {
    return;
  }

  window.scrollTo(0, 0);
});

window.router = {
  redirectTo(t) {
    return store.dispatch(replace(t));
  },
  transitionTo(t, escape = false) {
    if (escape) {
      let currentState = assign({}, window.history.state, {
        scrollTop: document.body.scrollTop,
      });

      window.history.replaceState(currentState, document.title, window.location.href);
      window.browserHistory.push(t);
    }

    return store.dispatch(push(t));
  },
};

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
});

const renderApp = () => {
  const container = document.getElementById('app-root');
  const root = createRoot(container);

  root.render(
    <ThemeProvider brand={brand}>
      <RpErrorBoundary>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <HydrationBoundary state={window.__QUERY_CLIENT__}>
              <Auth.Provider>
                <SCThemeProvider theme={ThemeConstellation}>
                  <CookiesProvider>
                    <Router history={history}>
                      <App />
                    </Router>
                  </CookiesProvider>
                </SCThemeProvider>
              </Auth.Provider>
            </HydrationBoundary>
          </QueryClientProvider>
        </Provider>
      </RpErrorBoundary>
    </ThemeProvider>,
  );
};

renderApp();

if (module.hot) {
  module.hot.accept();
}
